import tracer from "dd-trace";
import { isTraceableEnvironment } from "./is-traceable-environment";
export const getTraceId = ()=>{
    var ref;
    return isTraceableEnvironment() ? (ref = tracer.scope().active()) === null || ref === void 0 ? void 0 : ref.context().toTraceId() : "";
};
